import { render, staticRenderFns } from "./document_extraction_parameters_page.vue?vue&type=template&id=29d06343&scoped=true"
import script from "./document_extraction_parameters_page.vue?vue&type=script&lang=js"
export * from "./document_extraction_parameters_page.vue?vue&type=script&lang=js"
import style0 from "./document_extraction_parameters_page.vue?vue&type=style&index=0&id=29d06343&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d06343",
  null
  
)

export default component.exports